// Module
var code = "<record-form-view fields=\"componentController.formFields\" model=\"componentController.model\" title=\"Move Machines\" on-submit=\"componentController.submit(formViewController)\" on-cancel=\"componentController.cancel(formViewController)\"></record-form-view> ";
// Exports
export default code;